// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Webapi__Fetch = require("rescript-webapi/src/Webapi/Webapi__Fetch.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var LanguageSelectorPosition$ReactHooksTemplate = require("./LanguageSelectorPosition.res.js");

function decodeTranslationLanguage(json) {
  return {
          code: Json_decode.field("code", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          translationCount: Json_decode.field("translation_count", Json_decode.$$int, json),
          visibleInSelector: Json_decode.field("visible_in_selector", (function (param) {
                  return Json_decode.withDefault(true, Json_decode.bool, param);
                }), json)
        };
}

function decodeSummary(json) {
  return {
          sourceLanguage: Json_decode.field("source_language", SurveyLanguage$ReactHooksTemplate.fromJson, json),
          translationLanguages: Json_decode.field("translation_languages", (function (param) {
                  return Json_decode.list(decodeTranslationLanguage, param);
                }), json),
          languageSelectorPosition: LanguageSelectorPosition$ReactHooksTemplate.fromString(Json_decode.field("language_selector_position", (function (param) {
                      return Json_decode.withDefault("hidden", Json_decode.string, param);
                    }), json))
        };
}

function decodeIssue(json) {
  return {
          row: Json_decode.optional((function (param) {
                  return Json_decode.field("row", Json_decode.$$int, param);
                }), json),
          field: Json_decode.optional((function (param) {
                  return Json_decode.field("field", Json_decode.string, param);
                }), json),
          message: Json_decode.field("message", Json_decode.string, json)
        };
}

function decodeWarning(json) {
  return {
          row: Json_decode.optional((function (param) {
                  return Json_decode.field("row", Json_decode.$$int, param);
                }), json),
          field: undefined,
          message: Json_decode.field("message", Json_decode.string, json)
        };
}

function decodeImportSummary(json) {
  var languagesJson = Json_decode.optional((function (param) {
          return Json_decode.field("languages", (function (param) {
                        return Json_decode.dict(Json_decode.$$int, param);
                      }), param);
        }), json);
  var languages = languagesJson !== undefined ? Belt_List.map(Belt_List.sort(Belt_List.fromArray(Object.keys(languagesJson)), $$String.compare), (function (key) {
            return [
                    key,
                    languagesJson[key]
                  ];
          })) : /* [] */0;
  return {
          totalRows: Json_decode.field("total_rows", Json_decode.$$int, json),
          translatedRows: Json_decode.field("translated_rows", Json_decode.$$int, json),
          skippedBlank: Json_decode.field("skipped_blank", Json_decode.$$int, json),
          languages: languages
        };
}

function decodeValidationResult(json) {
  return {
          valid: Json_decode.field("valid", Json_decode.bool, json),
          summary: Json_decode.field("summary", decodeImportSummary, json),
          errors: Json_decode.field("errors", (function (param) {
                  return Json_decode.list(decodeIssue, param);
                }), json),
          warnings: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("warnings", (function (param) {
                                return Json_decode.list(decodeWarning, param);
                              }), param);
                }), json)
        };
}

function decodeValidationResponse(json) {
  var fallbackMessage = Json_decode.field("message", (function (param) {
          return Json_decode.withDefault("Validation failed.", Json_decode.string, param);
        }), json);
  var result = Json_decode.optional((function (param) {
          return Json_decode.field("data", decodeValidationResult, param);
        }), json);
  if (result !== undefined) {
    if (Belt_List.length(result.errors) > 0) {
      return {
              valid: result.valid,
              summary: result.summary,
              errors: result.errors,
              warnings: result.warnings
            };
    } else {
      return {
              valid: false,
              summary: result.summary,
              errors: {
                hd: {
                  row: undefined,
                  field: undefined,
                  message: fallbackMessage
                },
                tl: /* [] */0
              },
              warnings: result.warnings
            };
    }
  } else {
    return {
            valid: false,
            summary: {
              totalRows: 0,
              translatedRows: 0,
              skippedBlank: 0,
              languages: /* [] */0
            },
            errors: {
              hd: {
                row: undefined,
                field: undefined,
                message: fallbackMessage
              },
              tl: /* [] */0
            },
            warnings: /* [] */0
          };
  }
}

function fetchSummary(surveyId) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/surveys/" + String(surveyId) + "/translations", (function (json) {
                return Json_decode.field("data", decodeSummary, json);
              }));
}

function updateSelectorVisibility(surveyId, languages) {
  var params = {};
  params["languages"] = Belt_List.toArray(Belt_List.map(languages, (function (language) {
              return Json_encode.object_({
                          hd: [
                            "code",
                            language.code
                          ],
                          tl: {
                            hd: [
                              "visible_in_selector",
                              language.visibleInSelector
                            ],
                            tl: /* [] */0
                          }
                        });
            })));
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys/" + String(surveyId) + "/translations/selector_visibility", params);
}

function updateLanguageSelectorPosition(surveyId, position) {
  var params = {};
  params["position"] = LanguageSelectorPosition$ReactHooksTemplate.toString(position);
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys/" + String(surveyId) + "/translations/language_selector_position", params);
}

function removeTranslations(surveyId, languageCode) {
  var params = {};
  params["language_code"] = languageCode;
  return Http$ReactHooksTemplate.fetchPostJSON("/api/v1/surveys/" + String(surveyId) + "/translations/remove", params);
}

function fetchEnabledLanguages(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/survey_languages", (function (json) {
                return Json_decode.list(SurveyLanguage$ReactHooksTemplate.fromJson, json);
              }));
}

function downloadTemplate(surveyId, languageCodes, format, includeErrorNotifications, includeNavigationMessages) {
  var codesParam = Belt_List.reduce(languageCodes, "", (function (acc, code) {
          if (acc === "") {
            return code;
          } else {
            return acc + "," + code;
          }
        }));
  var includeErrorParam = includeErrorNotifications ? "true" : "false";
  var includeNavigationParam = includeNavigationMessages ? "true" : "false";
  var url = "/api/v1/surveys/" + String(surveyId) + "/translations/template?language_codes=" + codesParam + "&export_format=" + format + "&include_error_notifications=" + includeErrorParam + "&include_navigation_messages=" + includeNavigationParam;
  var navigate = (function(url) { window.location.href = url; });
  navigate(url);
}

function appendLanguageCodes(formData, languageCodes) {
  Belt_List.forEach(languageCodes, (function (code) {
          formData.append("language_codes[]", code);
        }));
}

function uploadTranslationFile(surveyId, languageCodes, file, validateOnly) {
  var formData = new FormData();
  appendLanguageCodes(formData, languageCodes);
  formData.append("file", file, undefined);
  var endpoint = validateOnly ? "/api/v1/surveys/" + String(surveyId) + "/translations/validate" : "/api/v1/surveys/" + String(surveyId) + "/translations/import";
  return Js_promise.then_((function (response) {
                return response.json();
              }), fetch(endpoint, Webapi__Fetch.RequestInit.make("Post", [
                      [
                        "X-CSRF-TOKEN",
                        Utils$ReactHooksTemplate.csrfToken
                      ],
                      [
                        "Accept",
                        "application/json"
                      ]
                    ], Caml_option.some(formData), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)));
}

function languageNameForCode(code, languages) {
  var language = Belt_List.getBy(languages, (function (lang) {
          return SurveyLanguage$ReactHooksTemplate.code(lang) === code;
        }));
  if (language !== undefined) {
    return SurveyLanguage$ReactHooksTemplate.name(language);
  } else {
    return code;
  }
}

function SurveyTranslations$StepHeader(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: String(props.number),
                      className: "flex-shrink-0 w-8 h-8 rounded-full bg-pigmentblue text-white flex items-center justify-center text-sm font-semibold"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: props.title,
                              className: "text-base font-semibold text-darkcharcoal"
                            }),
                        JsxRuntime.jsx("p", {
                              children: props.description,
                              className: "text-xs text-aurometalsaurus mt-1 leading-relaxed"
                            })
                      ]
                    })
              ],
              className: "flex items-start gap-3 mb-4"
            });
}

var StepHeader = {
  make: SurveyTranslations$StepHeader
};

function SurveyTranslations$StatCard(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: "text-xs font-medium uppercase tracking-wide text-aurometalsaurus mb-2"
                    }),
                props.children
              ],
              className: "bg-white border border-gray-300 rounded-lg p-4 h-full"
            });
}

var StatCard = {
  make: SurveyTranslations$StatCard
};

function SurveyTranslations$RemoveLanguageDialog(props) {
  var onConfirm = props.onConfirm;
  var onCancel = props.onCancel;
  var confirming = props.confirming;
  var language = props.language;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      className: "fixed inset-0 bg-gray-600 bg-opacity-50",
                      onClick: (function (param) {
                          if (!confirming) {
                            return Curry._1(onCancel, undefined);
                          }
                          
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("img", {
                                    className: "h-4 w-4",
                                    alt: "",
                                    src: Image$ReactHooksTemplate.closeIcon
                                  }),
                              className: "absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed",
                              disabled: confirming,
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onCancel, undefined);
                                })
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-5 w-5",
                                            alt: "",
                                            src: Image$ReactHooksTemplate.trash
                                          }),
                                      className: "w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center flex-shrink-0"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h2", {
                                              children: "Remove " + language.name + " from this survey?",
                                              className: "text-lg font-semibold text-darkcharcoal"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "This cannot be undone.",
                                              className: "text-sm text-aurometalsaurus mt-1"
                                            })
                                      ]
                                    })
                              ],
                              className: "flex items-start gap-3 mb-5 pr-6"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("p", {
                                    children: "Deletes " + String(language.translationCount) + " " + language.name + " translations permanently.",
                                    className: "text-sm text-darkcharcoal leading-relaxed"
                                  }),
                              className: "bg-ghostwhitegray border border-gray-200 rounded-lg p-4 mb-4"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("p", {
                                    children: "Hide keeps translations. Remove deletes them.",
                                    className: "text-xs text-darkcharcoal leading-relaxed"
                                  }),
                              className: "flex items-start bg-lavenderweb border border-gray-300 rounded-lg p-4 mb-6"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: "Cancel",
                                      className: "px-4 py-2 text-sm text-darkcharcoal bg-white border border-gray-300 rounded-lg hover:bg-ghostwhitegray disabled:opacity-50 disabled:cursor-not-allowed",
                                      disabled: confirming,
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(onCancel, undefined);
                                        })
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: confirming ? "Removing..." : "Remove permanently",
                                      className: "px-4 py-2 text-sm font-medium text-white bg-red-600 border border-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed",
                                      disabled: confirming,
                                      type: "button",
                                      onClick: (function (param) {
                                          Curry._1(onConfirm, undefined);
                                        })
                                    })
                              ],
                              className: "flex justify-end gap-3 border-t border-gray-200 pt-4"
                            })
                      ],
                      className: "relative bg-white w-full max-w-md rounded-xl shadow-2xl border border-gray-200 p-6 overflow-hidden"
                    })
              ],
              className: "fixed inset-0 z-50 flex items-center justify-center p-4"
            });
}

var RemoveLanguageDialog = {
  make: SurveyTranslations$RemoveLanguageDialog
};

var languageTableRowClass = "px-4 py-3 border-b border-gray-200 last:border-b-0 transition-colors duration-150";

var languageTableRowInnerClass = "flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4";

var languageDropdownColumnClass = "sm:w-250-px sm:flex-shrink-0";

var languageManageColumnClass = "sm:w-150-px sm:flex-shrink-0 flex sm:justify-end";

var languageTableHeaderClass = "hidden sm:flex sm:items-center gap-4 px-4 py-2 bg-gray-50 border-b border-gray-200";

function fileDisplayName(file) {
  var getName = (function(file) { return file.name; });
  return getName(file);
}

function translationFileSize(file) {
  var getSize = (function(file) { return file.size; });
  return getSize(file);
}

function allowedTranslationExtension(fileName) {
  var lower = fileName.toLowerCase();
  if (lower.endsWith(".csv")) {
    return true;
  } else {
    return lower.endsWith(".xlsx");
  }
}

function importedLanguageCodes(summaryData, targetLanguages) {
  return Belt_List.sort(Belt_List.keep(Belt_List.map(summaryData.translationLanguages, (function (lang) {
                        return lang.code;
                      })), (function (code) {
                    return Belt_List.some(targetLanguages, (function (lang) {
                                  return SurveyLanguage$ReactHooksTemplate.code(lang) === code;
                                }));
                  })), $$String.compare);
}

function uploadStepStateClass(state) {
  switch (state) {
    case "Upcoming" :
        return "bg-white border-gray-300 text-aurometalsaurus";
    case "Current" :
        return "bg-lavenderweb border-pigmentblue text-darkcharcoal";
    case "Complete" :
        return "bg-green-50 border-green-400 text-green-800";
    case "Failed" :
        return "bg-red-50 border-red-300 text-red-800";
    
  }
}

function selectedFileCardState(importMode) {
  if (typeof importMode !== "object") {
    switch (importMode) {
      case "Idle" :
          return [
                  "border-gray-300 bg-ghostwhitegray",
                  "Awaiting validation",
                  "text-aurometalsaurus"
                ];
      case "Validating" :
      case "Importing" :
          return [
                  "border-gray-300 bg-ghostwhitegray",
                  "",
                  "text-aurometalsaurus"
                ];
      
    }
  } else {
    if (importMode.TAG !== "Preview") {
      return [
              "border-gray-300 bg-ghostwhitegray",
              "Awaiting validation",
              "text-aurometalsaurus"
            ];
    }
    var match = importMode._0;
    if (match.valid) {
      return [
              "border-green-400 bg-green-50",
              "Validation passed — ready to import",
              "text-green-700"
            ];
    }
    var errorCount = Belt_List.length(match.errors);
    var subtitle = errorCount > 0 ? "Validation failed — " + String(errorCount) + " " + (
        errorCount === 1 ? "error" : "errors"
      ) + " found" : "Validation failed — review details below";
    return [
            "border-red-300 bg-red-50",
            subtitle,
            "text-red-700"
          ];
  }
}

function SurveyTranslations$UploadWorkflowSteps(props) {
  var hasFile = props.hasFile;
  var importMode = props.importMode;
  var uploadState;
  uploadState = typeof importMode !== "object" ? (
      hasFile ? "Complete" : "Current"
    ) : (
      importMode.TAG === "Success" || hasFile ? "Complete" : "Current"
    );
  var validateState;
  if (typeof importMode !== "object") {
    switch (importMode) {
      case "Idle" :
          validateState = hasFile ? "Current" : "Upcoming";
          break;
      case "Validating" :
          validateState = "Current";
          break;
      case "Importing" :
          validateState = "Complete";
          break;
      
    }
  } else {
    validateState = importMode.TAG === "Preview" && !importMode._0.valid ? "Failed" : "Complete";
  }
  var importState;
  if (typeof importMode !== "object") {
    switch (importMode) {
      case "Idle" :
      case "Validating" :
          importState = "Upcoming";
          break;
      case "Importing" :
          importState = "Current";
          break;
      
    }
  } else {
    importState = importMode.TAG === "Preview" ? (
        importMode._0.valid ? "Current" : "Upcoming"
      ) : "Complete";
  }
  var renderStep = function (label, state) {
    var icon;
    switch (state) {
      case "Upcoming" :
      case "Current" :
          icon = null;
          break;
      case "Complete" :
          icon = JsxRuntime.jsx("img", {
                className: "w-3.5 h-3.5",
                alt: "",
                src: Image$ReactHooksTemplate.greenTick
              });
          break;
      case "Failed" :
          icon = JsxRuntime.jsx("img", {
                className: "w-3.5 h-3.5",
                alt: "",
                src: Image$ReactHooksTemplate.lightErrorIcon
              });
          break;
      
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  icon,
                  JsxRuntime.jsx("span", {
                        children: label
                      })
                ],
                className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-medium " + uploadStepStateClass(state)
              });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                renderStep("1. Upload", uploadState),
                JsxRuntime.jsx("span", {
                      children: "→",
                      className: "text-aurometalsaurus text-xs hidden sm:inline"
                    }),
                renderStep("2. Validate", validateState),
                JsxRuntime.jsx("span", {
                      children: "→",
                      className: "text-aurometalsaurus text-xs hidden sm:inline"
                    }),
                renderStep("3. Import", importState)
              ],
              className: "flex flex-wrap items-center gap-2 mb-4"
            });
}

var UploadWorkflowSteps = {
  make: SurveyTranslations$UploadWorkflowSteps
};

function SurveyTranslations$FileUploadAlert(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                      className: "w-5 h-5 mt-0.5 flex-shrink-0",
                      alt: "",
                      src: Image$ReactHooksTemplate.lightErrorIcon
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: props.title,
                              className: "text-sm font-semibold text-red-800 mb-1"
                            }),
                        JsxRuntime.jsx("p", {
                              children: props.message,
                              className: "text-sm text-red-700 leading-relaxed"
                            })
                      ]
                    })
              ],
              className: "p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3"
            });
}

var FileUploadAlert = {
  make: SurveyTranslations$FileUploadAlert
};

function SurveyTranslations(props) {
  var onLanguageSelectorPositionChange = props.onLanguageSelectorPositionChange;
  var surveyId = props.surveyId;
  var match = React.useState(function (param) {
        return /* [] */0;
      });
  var setAvailableLanguages = match[1];
  var availableLanguages = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setSummary = match$1[1];
  var summary = match$1[0];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSelectedLanguageCodes = match$2[1];
  var selectedLanguageCodes = match$2[0];
  var match$3 = React.useState(function (param) {
        return "Idle";
      });
  var setImportMode = match$3[1];
  var importMode = match$3[0];
  var match$4 = React.useState(function (param) {
        
      });
  var setSelectedFile = match$4[1];
  var selectedFile = match$4[0];
  var match$5 = React.useState(function (param) {
        return true;
      });
  var setLoading = match$5[1];
  var match$6 = React.useState(function (param) {
        
      });
  var setVisibilitySavingCode = match$6[1];
  var visibilitySavingCode = match$6[0];
  var match$7 = React.useState(function (param) {
        
      });
  var setRemovalSavingCode = match$7[1];
  var removalSavingCode = match$7[0];
  var match$8 = React.useState(function (param) {
        return false;
      });
  var setPositionSaving = match$8[1];
  var positionSaving = match$8[0];
  var match$9 = React.useState(function (param) {
        
      });
  var setVisibilityError = match$9[1];
  var visibilityError = match$9[0];
  var match$10 = React.useState(function (param) {
        
      });
  var setRemovalError = match$10[1];
  var removalError = match$10[0];
  var match$11 = React.useState(function (param) {
        
      });
  var setPositionError = match$11[1];
  var positionError = match$11[0];
  var match$12 = React.useState(function (param) {
        
      });
  var setLanguageToRemove = match$12[1];
  var languageToRemove = match$12[0];
  var match$13 = React.useState(function (param) {
        
      });
  var setFileUploadError = match$13[1];
  var fileUploadError = match$13[0];
  var match$14 = React.useState(function (param) {
        return true;
      });
  var setIncludeErrorNotifications = match$14[1];
  var includeErrorNotifications = match$14[0];
  var match$15 = React.useState(function (param) {
        return true;
      });
  var setIncludeNavigationMessages = match$15[1];
  var includeNavigationMessages = match$15[0];
  var match$16 = React.useState(function (param) {
        return 0;
      });
  var setFileUploadScrollTick = match$16[1];
  var fileUploadScrollTick = match$16[0];
  var fileInputRef = React.useRef(null);
  var statusPanelRef = React.useRef(null);
  var uploadSectionRef = React.useRef(null);
  var fileActionsRef = React.useRef(null);
  var scrollUploadSectionIntoView = function (param) {
    var el = uploadSectionRef.current;
    if (el == null) {
      return ;
    }
    var scroll = (function(el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    scroll(el);
  };
  var scheduleScrollToUploadFeedback = function (param) {
    var raf = (function(cb) { requestAnimationFrame(function() { requestAnimationFrame(cb); }); });
    raf(function (param) {
          scrollUploadSectionIntoView();
          var el = statusPanelRef.current;
          if (el == null) {
            return ;
          }
          var scroll = (function(el) { el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
          scroll(el);
        });
  };
  React.useEffect((function (param) {
          if (typeof importMode === "object") {
            scheduleScrollToUploadFeedback();
          }
          
        }), [importMode]);
  React.useEffect((function (param) {
          if (fileUploadScrollTick > 0) {
            var raf = (function(cb) { requestAnimationFrame(function() { requestAnimationFrame(cb); }); });
            raf(function (param) {
                  var el = fileActionsRef.current;
                  if (el == null) {
                    return ;
                  }
                  var scroll = (function(el) { el.scrollIntoView({ behavior: 'smooth', block: 'end' }); });
                  scroll(el);
                });
          }
          
        }), [fileUploadScrollTick]);
  var triggerFileSelect = function (param) {
    var el = fileInputRef.current;
    if (el == null) {
      return ;
    }
    var click = (function(el) { el.click(); });
    click(el);
  };
  var loadData = function (param) {
    Curry._1(setLoading, (function (param) {
            return true;
          }));
    Js_promise.$$catch((function (param) {
            return Promise.resolve(Curry._1(setLoading, (function (param) {
                              return false;
                            })));
          }), Js_promise.then_((function (param) {
                var summaryData = param[0];
                Curry._1(setSummary, (function (param) {
                        return summaryData;
                      }));
                var sourceCode = SurveyLanguage$ReactHooksTemplate.code(summaryData.sourceLanguage);
                var targetLanguages = Belt_List.keep(param[1], (function (language) {
                        return SurveyLanguage$ReactHooksTemplate.code(language) !== sourceCode;
                      }));
                Curry._1(setAvailableLanguages, (function (param) {
                        return targetLanguages;
                      }));
                var match = Belt_List.length(selectedLanguageCodes);
                if (match === 0) {
                  var codes = importedLanguageCodes(summaryData, targetLanguages);
                  if (codes) {
                    Curry._1(setSelectedLanguageCodes, (function (param) {
                            return codes;
                          }));
                  } else {
                    var language = Belt_List.head(targetLanguages);
                    if (language !== undefined) {
                      Curry._1(setSelectedLanguageCodes, (function (param) {
                              return {
                                      hd: SurveyLanguage$ReactHooksTemplate.code(language),
                                      tl: /* [] */0
                                    };
                            }));
                    }
                    
                  }
                }
                return Promise.resolve(Curry._1(setLoading, (function (param) {
                                  return false;
                                })));
              }), Promise.all([
                  fetchSummary(surveyId),
                  fetchEnabledLanguages()
                ])));
  };
  var refreshSummary = function (param) {
    Js_promise.$$catch((function (param) {
            return Promise.resolve();
          }), Js_promise.then_((function (summaryData) {
                Curry._1(setSummary, (function (param) {
                        return summaryData;
                      }));
                return Promise.resolve();
              }), fetchSummary(surveyId)));
  };
  React.useEffect((function (param) {
          loadData();
        }), []);
  var isImportBusy;
  if (typeof importMode !== "object") {
    switch (importMode) {
      case "Validating" :
      case "Importing" :
          isImportBusy = true;
          break;
      default:
        isImportBusy = false;
    }
  } else {
    isImportBusy = false;
  }
  var validationPreviewResult;
  validationPreviewResult = typeof importMode !== "object" || importMode.TAG !== "Preview" ? undefined : importMode._0;
  var showResultStatusPanel;
  showResultStatusPanel = typeof importMode !== "object" ? false : true;
  var renderProgressRow = function (message) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "w-5 h-5 flex-shrink-0",
                        alt: "",
                        src: Image$ReactHooksTemplate.sandClock
                      }),
                  JsxRuntime.jsx("span", {
                        children: message,
                        className: "text-sm font-medium text-darkcharcoal"
                      })
                ],
                className: "flex items-center gap-3 py-1"
              });
  };
  var handleFileChange = function ($$event) {
    var target = $$event.target;
    var file = Caml_array.get(target.files, 0);
    target.value = "";
    if (file === undefined) {
      return ;
    }
    var file$1 = Caml_option.valFromOption(file);
    var fileName = fileDisplayName(file$1);
    if (allowedTranslationExtension(fileName)) {
      if (translationFileSize(file$1) > 5242880) {
        Curry._1(setFileUploadError, (function (param) {
                return "File exceeds maximum allowed size of 5MB.";
              }));
        Curry._1(setSelectedFile, (function (param) {
                
              }));
        return Curry._1(setImportMode, (function (param) {
                      return "Idle";
                    }));
      } else {
        Curry._1(setSelectedFile, (function (param) {
                return Caml_option.some(file$1);
              }));
        Curry._1(setImportMode, (function (param) {
                return "Idle";
              }));
        Curry._1(setFileUploadError, (function (param) {
                
              }));
        return Curry._1(setFileUploadScrollTick, (function (tick) {
                      return tick + 1 | 0;
                    }));
      }
    } else {
      Curry._1(setFileUploadError, (function (param) {
              return "Only CSV and XLSX files with a single extension are allowed.";
            }));
      Curry._1(setSelectedFile, (function (param) {
              
            }));
      return Curry._1(setImportMode, (function (param) {
                    return "Idle";
                  }));
    }
  };
  var selectedLanguageCodesList = Belt_List.sort(selectedLanguageCodes, $$String.compare);
  var cancelRemoveLanguage = function (param) {
    if (removalSavingCode === undefined) {
      return Curry._1(setLanguageToRemove, (function (param) {
                    
                  }));
    }
    
  };
  var handleLanguageSelectorPositionChange = function ($$event) {
    var position = $$event.target.value;
    var nextPosition = LanguageSelectorPosition$ReactHooksTemplate.fromString(position);
    Curry._1(setPositionSaving, (function (param) {
            return true;
          }));
    Curry._1(setPositionError, (function (param) {
            
          }));
    Js_promise.$$catch((function (param) {
            Curry._1(setPositionSaving, (function (param) {
                    return false;
                  }));
            Curry._1(setPositionError, (function (param) {
                    return "Network error while updating language selector position.";
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (json) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failure", Json_decode.string, param);
                      }), json);
                if (status === "success") {
                  var summaryData = Json_decode.field("data", decodeSummary, json);
                  Curry._1(setSummary, (function (param) {
                          return summaryData;
                        }));
                  Curry._1(setPositionError, (function (param) {
                          
                        }));
                  if (onLanguageSelectorPositionChange !== undefined) {
                    Curry._1(onLanguageSelectorPositionChange, nextPosition);
                  }
                  
                } else {
                  var message = Json_decode.field("message", (function (param) {
                          return Json_decode.withDefault("Failed to update language selector position.", Json_decode.string, param);
                        }), json);
                  Curry._1(setPositionError, (function (param) {
                          return message;
                        }));
                }
                return Promise.resolve(Curry._1(setPositionSaving, (function (param) {
                                  return false;
                                })));
              }), updateLanguageSelectorPosition(surveyId, nextPosition)));
  };
  var languagePositionOptions = Belt_List.map(LanguageSelectorPosition$ReactHooksTemplate.allPositions, (function (pos) {
          return {
                  label: LanguageSelectorPosition$ReactHooksTemplate.label(pos),
                  value: LanguageSelectorPosition$ReactHooksTemplate.toString(pos)
                };
        }));
  var handleValidate = function (param) {
    if (selectedFile !== undefined && Belt_List.length(selectedLanguageCodesList) !== 0) {
      Curry._1(setImportMode, (function (param) {
              return "Validating";
            }));
      Js_promise.$$catch((function (param) {
              Curry._1(setImportMode, (function (param) {
                      return {
                              TAG: "Preview",
                              _0: {
                                valid: false,
                                summary: {
                                  totalRows: 0,
                                  translatedRows: 0,
                                  skippedBlank: 0,
                                  languages: /* [] */0
                                },
                                errors: {
                                  hd: {
                                    row: undefined,
                                    field: undefined,
                                    message: "Network error during validation."
                                  },
                                  tl: /* [] */0
                                },
                                warnings: /* [] */0
                              }
                            };
                    }));
              return Promise.resolve();
            }), Js_promise.then_((function (json) {
                  var status = Json_decode.field("status", (function (param) {
                          return Json_decode.withDefault("failure", Json_decode.string, param);
                        }), json);
                  if (status === "success") {
                    var result = Json_decode.field("data", decodeValidationResult, json);
                    Curry._1(setImportMode, (function (param) {
                            return {
                                    TAG: "Preview",
                                    _0: result
                                  };
                          }));
                  } else {
                    Curry._1(setImportMode, (function (param) {
                            return {
                                    TAG: "Preview",
                                    _0: decodeValidationResponse(json)
                                  };
                          }));
                  }
                  return Promise.resolve();
                }), uploadTranslationFile(surveyId, selectedLanguageCodesList, Caml_option.valFromOption(selectedFile), true)));
      return ;
    }
    
  };
  var renderIssues = function (tone, title, issues) {
    if (!issues) {
      return null;
    }
    var containerClass = tone === "warning" ? "bg-orange-50 border-orange-200" : "bg-red-50 border-red-200";
    var titleClass = tone === "warning" ? "text-orange-800" : "text-red-800";
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: title,
                        className: "text-sm font-medium mb-2 " + titleClass
                      }),
                  JsxRuntime.jsx("div", {
                        children: $$Array.of_list(Belt_List.mapWithIndex(issues, (function (index, issue) {
                                    var row = issue.row;
                                    return JsxRuntime.jsx("div", {
                                                children: row !== undefined ? "Row " + String(row) + ": " + issue.message : issue.message,
                                                className: "text-xs text-darkcharcoal mb-2 leading-relaxed"
                                              }, String(index));
                                  }))),
                        className: "border rounded p-3 max-h-48 overflow-y-auto " + containerClass
                      })
                ],
                className: "mt-4"
              });
  };
  var renderLanguageChip = function (language) {
    var code = SurveyLanguage$ReactHooksTemplate.code(language);
    var name = SurveyLanguage$ReactHooksTemplate.name(language);
    var selected = Belt_List.has(selectedLanguageCodes, code, (function (a, b) {
            return a === b;
          }));
    return JsxRuntime.jsxs("button", {
                children: [
                  selected ? JsxRuntime.jsx("img", {
                          className: "w-4 h-4",
                          alt: "",
                          src: Image$ReactHooksTemplate.greenTick
                        }) : JsxRuntime.jsx("span", {
                          className: "w-4 h-4 rounded-full border border-gray-400 inline-block"
                        }),
                  JsxRuntime.jsx("span", {
                        children: name
                      }),
                  JsxRuntime.jsx("span", {
                        children: code,
                        className: "text-xs text-aurometalsaurus"
                      })
                ],
                className: "inline-flex items-center gap-2 px-3 py-2 rounded-full border text-sm transition-colors duration-150 " + (
                  selected ? "bg-lavenderweb border-pigmentblue text-darkcharcoal" : "bg-white border-gray-300 text-darkcharcoal hover:border-pigmentblue hover:bg-ghostwhitegray"
                ),
                type: "button",
                onClick: (function (param) {
                    Curry._1(setSelectedLanguageCodes, (function (prev) {
                            if (Belt_List.has(prev, code, (function (a, b) {
                                      return a === b;
                                    }))) {
                              return Belt_List.keep(prev, (function (c) {
                                            return c !== code;
                                          }));
                            } else {
                              return Belt_List.add(prev, code);
                            }
                          }));
                    Curry._1(setImportMode, (function (param) {
                            return "Idle";
                          }));
                  })
              }, code);
  };
  var renderImportedLanguageBadge = function (language) {
    return JsxRuntime.jsxs("span", {
                children: [
                  language.name,
                  JsxRuntime.jsx("span", {
                        children: "(" + String(language.translationCount) + ")",
                        className: "text-aurometalsaurus"
                      })
                ],
                className: "inline-flex items-center gap-1 bg-magnolia text-darkcharcoal text-xs font-medium px-2 py-1 rounded mr-2 mb-2"
              }, language.code);
  };
  var renderSourceLanguageRow = function (summaryData) {
    var name = SurveyLanguage$ReactHooksTemplate.name(summaryData.sourceLanguage);
    var code = SurveyLanguage$ReactHooksTemplate.code(summaryData.sourceLanguage);
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("img", {
                                      className: "w-4 h-4 flex-shrink-0 opacity-50",
                                      alt: "",
                                      src: Image$ReactHooksTemplate.lock
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: name,
                                              className: "text-sm font-medium text-darkcharcoal"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: code + " · source language",
                                              className: "text-xs text-aurometalsaurus"
                                            })
                                      ],
                                      className: "min-w-0"
                                    })
                              ],
                              className: "flex items-center gap-3 min-w-0 flex-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: "Visibility",
                                      className: "sm:hidden text-xs font-medium uppercase tracking-wide text-aurometalsaurus mb-1 block"
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: "Always visible",
                                      className: "text-xs font-medium text-pigmentblue"
                                    })
                              ],
                              className: languageDropdownColumnClass
                            }),
                        JsxRuntime.jsx("div", {
                              className: languageManageColumnClass
                            })
                      ],
                      className: languageTableRowInnerClass
                    }),
                className: languageTableRowClass + " bg-ghostwhitegray"
              });
  };
  var renderRemoveLanguageButton = function (language, rowBusy, removalSaving) {
    if (removalSaving) {
      return JsxRuntime.jsx("span", {
                  children: "Removing...",
                  className: "text-xs text-aurometalsaurus whitespace-nowrap"
                });
    } else {
      return JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("img", {
                          className: "h-12-px w-12-px flex-shrink-0",
                          alt: "",
                          src: Image$ReactHooksTemplate.trash
                        }),
                    "Remove…"
                  ],
                  className: "inline-flex items-center gap-2 px-3 py-2 text-xs font-medium text-red-600 border border-red-200 rounded-lg bg-white hover:bg-red-50 hover:border-red-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap",
                  disabled: rowBusy,
                  type: "button",
                  onClick: (function (param) {
                      Curry._1(setLanguageToRemove, (function (param) {
                              return language;
                            }));
                    })
                });
    }
  };
  var renderSelectorVisibilityRow = function (language) {
    var visibilitySaving = Caml_obj.equal(visibilitySavingCode, language.code);
    var removalSaving = Caml_obj.equal(removalSavingCode, language.code);
    var rowBusy = visibilitySaving || removalSaving;
    var visible = language.visibleInSelector;
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: language.name,
                                                    className: "text-sm font-medium text-darkcharcoal"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: language.code + " · " + String(language.translationCount) + " resources",
                                                    className: "text-xs text-aurometalsaurus"
                                                  })
                                            ],
                                            className: "min-w-0"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: renderRemoveLanguageButton(language, rowBusy, removalSaving),
                                            className: "flex-shrink-0 sm:hidden"
                                          })
                                    ],
                                    className: "flex items-start justify-between gap-3 sm:block"
                                  }),
                              className: "min-w-0 flex-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: "Visibility",
                                      className: "sm:hidden text-xs font-medium uppercase tracking-wide text-aurometalsaurus mb-1 block"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        visibilitySaving ? JsxRuntime.jsx("span", {
                                                children: "Saving...",
                                                className: "text-xs text-aurometalsaurus whitespace-nowrap"
                                              }) : JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                checked: visible,
                                                disabled: rowBusy,
                                                handleChange: (function (param) {
                                                    var nextVisible = !language.visibleInSelector;
                                                    Curry._1(setVisibilitySavingCode, (function (param) {
                                                            return language.code;
                                                          }));
                                                    Curry._1(setVisibilityError, (function (param) {
                                                            
                                                          }));
                                                    Js_promise.$$catch((function (param) {
                                                            Curry._1(setVisibilitySavingCode, (function (param) {
                                                                    
                                                                  }));
                                                            Curry._1(setVisibilityError, (function (param) {
                                                                    return "Network error while updating language visibility.";
                                                                  }));
                                                            return Promise.resolve();
                                                          }), Js_promise.then_((function (json) {
                                                                var status = Json_decode.field("status", (function (param) {
                                                                        return Json_decode.withDefault("failure", Json_decode.string, param);
                                                                      }), json);
                                                                if (status === "success") {
                                                                  var summaryData = Json_decode.field("data", decodeSummary, json);
                                                                  Curry._1(setSummary, (function (param) {
                                                                          return summaryData;
                                                                        }));
                                                                  Curry._1(setVisibilityError, (function (param) {
                                                                          
                                                                        }));
                                                                } else {
                                                                  var message = Json_decode.field("message", (function (param) {
                                                                          return Json_decode.withDefault("Failed to update language visibility.", Json_decode.string, param);
                                                                        }), json);
                                                                  Curry._1(setVisibilityError, (function (param) {
                                                                          return message;
                                                                        }));
                                                                }
                                                                return Promise.resolve(Curry._1(setVisibilitySavingCode, (function (param) {
                                                                                  
                                                                                })));
                                                              }), updateSelectorVisibility(surveyId, {
                                                                  hd: {
                                                                    code: language.code,
                                                                    name: language.name,
                                                                    translationCount: language.translationCount,
                                                                    visibleInSelector: nextVisible
                                                                  },
                                                                  tl: /* [] */0
                                                                })));
                                                  }),
                                                labelClassName: "flex items-center flex-shrink-0"
                                              }),
                                        JsxRuntime.jsx("span", {
                                              children: visible ? "Visible" : "Hidden",
                                              className: "text-xs text-aurometalsaurus leading-snug"
                                            })
                                      ],
                                      className: "flex items-center gap-2"
                                    })
                              ],
                              className: languageDropdownColumnClass
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: "Actions",
                                      className: "sm:hidden text-xs font-medium uppercase tracking-wide text-aurometalsaurus mb-1 block"
                                    }),
                                renderRemoveLanguageButton(language, rowBusy, removalSaving)
                              ],
                              className: languageManageColumnClass + " hidden sm:flex"
                            })
                      ],
                      className: languageTableRowInnerClass
                    }),
                className: languageTableRowClass + (
                  rowBusy ? " opacity-60" : " hover:bg-ghostwhitegray"
                )
              }, language.code);
  };
  var respondentLanguageCount = function (summaryData) {
    var visibleImported = Belt_List.length(Belt_List.keep(summaryData.translationLanguages, (function (language) {
                return language.visibleInSelector;
              })));
    return 1 + visibleImported | 0;
  };
  var renderRespondentLanguageSelectorPanel = function (summaryData) {
    var languages = summaryData.translationLanguages;
    var visibleImportedCount = Belt_List.length(Belt_List.keep(languages, (function (language) {
                return language.visibleInSelector;
              })));
    var totalCount = 1 + Belt_List.length(languages) | 0;
    var visibleCount = 1 + visibleImportedCount | 0;
    var positionDisabled = respondentLanguageCount(summaryData) < 2;
    var position = summaryData.languageSelectorPosition;
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h3", {
                                        children: "Respondent language selector",
                                        className: "text-base font-semibold text-darkcharcoal mb-1"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: "Languages respondents can pick, and where the selector appears.",
                                        className: "text-xs text-aurometalsaurus leading-relaxed max-w-xl"
                                      })
                                ]
                              }),
                          JsxRuntime.jsx("span", {
                                children: String(visibleCount) + " of " + String(totalCount) + " shown",
                                className: "inline-flex self-start items-center px-2.5 py-1 text-xs font-medium text-darkcharcoal bg-ghostwhitegray border border-gray-200 rounded-full whitespace-nowrap"
                              })
                        ],
                        className: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-6"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h4", {
                                children: "Placement",
                                className: "text-sm font-semibold text-darkcharcoal mb-1"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Where the language selector appears on the welcome page.",
                                className: "text-xs text-aurometalsaurus mb-4 leading-relaxed max-w-2xl"
                              }),
                          JsxRuntime.jsx("label", {
                                children: "Position",
                                className: "block text-sm font-medium text-darkcharcoal mb-2"
                              }),
                          JsxRuntime.jsx("select", {
                                children: $$Array.of_list(Belt_List.map(languagePositionOptions, (function (option) {
                                            return JsxRuntime.jsx("option", {
                                                        children: option.label,
                                                        value: option.value
                                                      }, option.value);
                                          }))),
                                className: "h-10 block border px-2 py-1 border-gray-400 bg-white rounded text-sm w-full max-w-sm " + (
                                  positionDisabled || positionSaving ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
                                ),
                                disabled: positionDisabled || positionSaving,
                                value: LanguageSelectorPosition$ReactHooksTemplate.toString(position),
                                onChange: handleLanguageSelectorPositionChange
                              }),
                          positionSaving ? JsxRuntime.jsx("p", {
                                  children: "Saving...",
                                  className: "mt-2 text-xs text-aurometalsaurus"
                                }) : null,
                          positionDisabled ? JsxRuntime.jsx("p", {
                                  children: "Needs 2+ visible languages.",
                                  className: "mt-3 text-xs text-aurometalsaurus leading-relaxed max-w-2xl"
                                }) : null,
                          !positionDisabled && position === "Hidden" ? JsxRuntime.jsx("p", {
                                  children: "Hidden: respondents can't switch languages.",
                                  className: "mt-3 text-xs text-firebrick leading-relaxed max-w-2xl"
                                }) : null,
                          positionError !== undefined ? JsxRuntime.jsx("p", {
                                  children: positionError,
                                  className: "mt-3 text-sm text-red-600"
                                }) : null
                        ],
                        className: "mb-8 pb-8 border-b border-gray-200"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h4", {
                                children: "Languages",
                                className: "text-sm font-semibold text-darkcharcoal mb-1"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Toggle visibility. Remove deletes translations.",
                                className: "text-xs text-aurometalsaurus mb-4 leading-relaxed max-w-2xl"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "Language",
                                                className: "flex-1 text-xs font-medium uppercase tracking-wide text-aurometalsaurus"
                                              }),
                                          JsxRuntime.jsx("span", {
                                                children: "Visibility",
                                                className: languageDropdownColumnClass + " text-xs font-medium uppercase tracking-wide text-aurometalsaurus"
                                              }),
                                          JsxRuntime.jsx("span", {
                                                children: "Actions",
                                                className: languageManageColumnClass + " text-xs font-medium uppercase tracking-wide text-aurometalsaurus"
                                              })
                                        ],
                                        className: languageTableHeaderClass
                                      }),
                                  renderSourceLanguageRow(summaryData),
                                  $$Array.of_list(Belt_List.map(languages, renderSelectorVisibilityRow))
                                ],
                                className: "border border-gray-200 rounded-lg"
                              }),
                          visibilityError !== undefined ? JsxRuntime.jsx("p", {
                                  children: visibilityError,
                                  className: "mt-3 text-sm text-red-600"
                                }) : null,
                          removalError !== undefined ? JsxRuntime.jsx("p", {
                                  children: removalError,
                                  className: "mt-3 text-sm text-red-600"
                                }) : null
                        ]
                      })
                ],
                className: "bg-white border border-gray-300 rounded-lg p-6 mb-6"
              });
  };
  var renderLoadingState = function (param) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "w-10 h-10 mb-4 opacity-60",
                        alt: "",
                        src: Image$ReactHooksTemplate.loadingList
                      }),
                  JsxRuntime.jsx("p", {
                        children: "Loading translation settings...",
                        className: "text-sm text-darkcharcoal"
                      })
                ],
                className: "flex flex-col items-center justify-center py-16 text-center"
              });
  };
  var renderStatusPanel = function (param) {
    if (typeof importMode !== "object") {
      return null;
    }
    if (importMode.TAG !== "Preview") {
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                          className: "w-5 h-5 mt-0.5 flex-shrink-0",
                          alt: "",
                          src: Image$ReactHooksTemplate.greenTick
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Import complete",
                                  className: "text-sm font-medium text-green-800 mb-1"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: importMode._0,
                                  className: "text-sm text-green-700"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: "Imported translation counts above have been updated. Upload another file when you are ready to import more.",
                                  className: "text-xs text-green-700 mt-2 leading-relaxed"
                                })
                          ]
                        })
                  ],
                  ref: Caml_option.some(statusPanelRef),
                  className: "p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3"
                });
    }
    var result = importMode._0;
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "w-5 h-5 mt-0.5 flex-shrink-0",
                              alt: "",
                              src: result.valid ? Image$ReactHooksTemplate.greenTick : Image$ReactHooksTemplate.lightErrorIcon
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: result.valid ? "Validation passed" : "Validation failed",
                                      className: "text-sm font-semibold mb-2 " + (
                                        result.valid ? "text-green-800" : "text-red-800"
                                      )
                                    }),
                                result.valid ? null : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                        children: [
                                          renderIssues("error", "Fix these issues in your file", result.errors),
                                          renderIssues("warning", "Warnings", result.warnings)
                                        ]
                                      }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "Total rows: " + String(result.summary.totalRows),
                                              className: "inline-flex items-center bg-white border border-gray-300 rounded px-2 py-1 text-xs text-darkcharcoal"
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "Translated: " + String(result.summary.translatedRows),
                                              className: "inline-flex items-center bg-white border border-gray-300 rounded px-2 py-1 text-xs text-darkcharcoal"
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: "Blank: " + String(result.summary.skippedBlank),
                                              className: "inline-flex items-center bg-white border border-gray-300 rounded px-2 py-1 text-xs text-darkcharcoal"
                                            })
                                      ],
                                      className: "flex flex-wrap gap-2 mb-2"
                                    }),
                                Belt_List.length(result.summary.languages) > 0 ? JsxRuntime.jsx("div", {
                                        children: $$Array.of_list(Belt_List.map(result.summary.languages, (function (param) {
                                                    var code = param[0];
                                                    return JsxRuntime.jsx("span", {
                                                                children: languageNameForCode(code, availableLanguages) + " (" + String(param[1]) + ")",
                                                                className: "inline-flex items-center bg-magnolia text-darkcharcoal text-xs font-medium px-2 py-1 rounded"
                                                              }, code);
                                                  }))),
                                        className: "flex flex-wrap gap-2 mb-1"
                                      }) : null,
                                result.valid ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                        children: [
                                          renderIssues("warning", "Warnings", result.warnings),
                                          JsxRuntime.jsx("p", {
                                                children: "Your file is ready. Click Import translations to apply changes.",
                                                className: "text-xs text-green-700 mt-2"
                                              })
                                        ]
                                      }) : JsxRuntime.jsx("p", {
                                        children: "Update your file, upload it again, then click Validate file to retry.",
                                        className: "text-xs text-red-700 mt-2"
                                      })
                              ],
                              className: "flex-1 min-w-0"
                            })
                      ],
                      className: "flex items-start gap-3"
                    }),
                ref: Caml_option.some(statusPanelRef),
                className: "p-5 border rounded-lg " + (
                  result.valid ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200"
                )
              });
  };
  var tmp;
  if (match$5[0]) {
    tmp = renderLoadingState();
  } else {
    var tmp$1;
    if (selectedFile !== undefined) {
      var match$17 = selectedFileCardState(importMode);
      var subtitle = match$17[1];
      tmp$1 = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "w-6 h-6 flex-shrink-0",
                            alt: "",
                            src: Image$ReactHooksTemplate.hashDoc
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: fileDisplayName(Caml_option.valFromOption(selectedFile)),
                                    className: "text-sm font-medium text-darkcharcoal truncate"
                                  }),
                              subtitle !== "" ? JsxRuntime.jsx("p", {
                                      children: subtitle,
                                      className: "text-xs " + match$17[2]
                                    }) : null
                            ],
                            className: "min-w-0"
                          })
                    ],
                    className: "flex items-center gap-3 min-w-0"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: "Replace",
                            className: "text-xs font-medium text-pigmentblue hover:text-cetaceanblue px-2 py-1 disabled:opacity-50 disabled:cursor-not-allowed",
                            disabled: isImportBusy,
                            type: "button",
                            onClick: (function (param) {
                                triggerFileSelect();
                              })
                          }),
                      JsxRuntime.jsx("button", {
                            children: "Remove",
                            className: "text-xs font-medium text-aurometalsaurus hover:text-darkcharcoal px-2 py-1 disabled:opacity-50 disabled:cursor-not-allowed",
                            disabled: isImportBusy,
                            type: "button",
                            onClick: (function (param) {
                                Curry._1(setSelectedFile, (function (param) {
                                        
                                      }));
                                Curry._1(setImportMode, (function (param) {
                                        return "Idle";
                                      }));
                                Curry._1(setFileUploadError, (function (param) {
                                        
                                      }));
                              })
                          })
                    ],
                    className: "flex items-center gap-2 flex-shrink-0"
                  })
            ],
            className: "border rounded-lg p-4 flex items-center justify-between gap-4 " + match$17[0]
          });
    } else {
      tmp$1 = JsxRuntime.jsxs("button", {
            children: [
              JsxRuntime.jsx("img", {
                    className: "w-8 h-8 mx-auto mb-3 opacity-70",
                    alt: "",
                    src: Image$ReactHooksTemplate.clipboard
                  }),
              JsxRuntime.jsx("p", {
                    children: "Choose a file to upload",
                    className: "text-sm font-medium text-darkcharcoal mb-1"
                  }),
              JsxRuntime.jsx("p", {
                    children: "CSV or XLSX · Max 5MB · Click to browse",
                    className: "text-xs text-aurometalsaurus"
                  })
            ],
            className: "w-full border-2 border-dashed border-gray-400 rounded-lg p-8 text-center bg-ghostwhitegray hover:border-pigmentblue hover:bg-lavenderweb transition-colors duration-150",
            type: "button",
            onClick: (function (param) {
                triggerFileSelect();
              })
          });
    }
    var tmp$2;
    if (selectedFile !== undefined) {
      var tmp$3;
      if (typeof importMode !== "object") {
        switch (importMode) {
          case "Idle" :
              tmp$3 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Next step: validate your file",
                                    className: "text-sm font-semibold text-darkcharcoal"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "We'll check columns, languages, and row format before you can import.",
                                    className: "text-xs text-aurometalsaurus mt-1 leading-relaxed"
                                  })
                            ],
                            className: "mb-3"
                          }),
                      JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-4 h-4",
                                    alt: "",
                                    src: Image$ReactHooksTemplate.previewEye
                                  }),
                              "Validate file"
                            ],
                            className: "inline-flex items-center gap-2 border rounded-lg px-5 py-2.5 text-sm font-medium shadow-sm " + (
                              Belt_List.length(selectedLanguageCodesList) === 0 ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed" : "bg-pigmentblue border-pigmentblue text-white hover:bg-cetaceanblue"
                            ),
                            disabled: Belt_List.length(selectedLanguageCodesList) === 0,
                            type: "button",
                            onClick: (function (param) {
                                handleValidate();
                              })
                          })
                    ]
                  });
              break;
          case "Validating" :
              tmp$3 = renderProgressRow("Validating your file...");
              break;
          case "Importing" :
              tmp$3 = renderProgressRow("Importing translations. This may take a moment...");
              break;
          
        }
      } else {
        tmp$3 = importMode.TAG === "Preview" ? (
            importMode._0.valid ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Ready to import",
                                    className: "text-sm font-semibold text-darkcharcoal"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Validation passed. Import to apply translations to this survey.",
                                    className: "text-xs text-aurometalsaurus mt-1 leading-relaxed"
                                  })
                            ],
                            className: "mb-3"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("button", {
                                    children: [
                                      JsxRuntime.jsx("img", {
                                            className: "w-4 h-4",
                                            alt: "",
                                            src: Image$ReactHooksTemplate.submit
                                          }),
                                      "Import translations"
                                    ],
                                    className: "inline-flex items-center gap-2 border rounded-lg px-5 py-2.5 text-sm font-medium shadow-sm " + (
                                      Belt_List.length(selectedLanguageCodesList) === 0 ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed" : "bg-pigmentblue border-pigmentblue text-white hover:bg-cetaceanblue"
                                    ),
                                    disabled: Belt_List.length(selectedLanguageCodesList) === 0,
                                    type: "button",
                                    onClick: (function (param) {
                                        if (selectedFile !== undefined) {
                                          Curry._1(setImportMode, (function (param) {
                                                  return "Importing";
                                                }));
                                          Js_promise.$$catch((function (param) {
                                                  Curry._1(setImportMode, (function (param) {
                                                          return {
                                                                  TAG: "Preview",
                                                                  _0: {
                                                                    valid: false,
                                                                    summary: {
                                                                      totalRows: 0,
                                                                      translatedRows: 0,
                                                                      skippedBlank: 0,
                                                                      languages: /* [] */0
                                                                    },
                                                                    errors: {
                                                                      hd: {
                                                                        row: undefined,
                                                                        field: undefined,
                                                                        message: "Network error during import."
                                                                      },
                                                                      tl: /* [] */0
                                                                    },
                                                                    warnings: /* [] */0
                                                                  }
                                                                };
                                                        }));
                                                  return Promise.resolve();
                                                }), Js_promise.then_((function (json) {
                                                      var status = Json_decode.field("status", (function (param) {
                                                              return Json_decode.withDefault("failure", Json_decode.string, param);
                                                            }), json);
                                                      if (status === "success") {
                                                        var message = Json_decode.field("message", (function (param) {
                                                                return Json_decode.withDefault("Translations imported.", Json_decode.string, param);
                                                              }), json);
                                                        Curry._1(setImportMode, (function (param) {
                                                                return {
                                                                        TAG: "Success",
                                                                        _0: message
                                                                      };
                                                              }));
                                                        Curry._1(setSelectedFile, (function (param) {
                                                                
                                                              }));
                                                        refreshSummary();
                                                      } else {
                                                        Curry._1(setImportMode, (function (param) {
                                                                return {
                                                                        TAG: "Preview",
                                                                        _0: decodeValidationResponse(json)
                                                                      };
                                                              }));
                                                      }
                                                      return Promise.resolve();
                                                    }), uploadTranslationFile(surveyId, selectedLanguageCodesList, Caml_option.valFromOption(selectedFile), false)));
                                          return ;
                                        }
                                        
                                      })
                                  }),
                              validationPreviewResult !== undefined ? JsxRuntime.jsx("span", {
                                      children: String(validationPreviewResult.summary.translatedRows) + " translations ready to import",
                                      className: "text-xs text-green-700"
                                    }) : null
                            ],
                            className: "flex flex-wrap items-center gap-3"
                          })
                    ]
                  }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Fix issues and validate again",
                                    className: "text-sm font-semibold text-darkcharcoal"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Review the errors above, update your file if needed, then validate again.",
                                    className: "text-xs text-aurometalsaurus mt-1 leading-relaxed"
                                  })
                            ],
                            className: "mb-3"
                          }),
                      JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-4 h-4",
                                    alt: "",
                                    src: Image$ReactHooksTemplate.previewEye
                                  }),
                              "Validate file"
                            ],
                            className: "inline-flex items-center gap-2 border rounded-lg px-5 py-2.5 text-sm font-medium shadow-sm " + (
                              Belt_List.length(selectedLanguageCodesList) === 0 ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed" : "bg-pigmentblue border-pigmentblue text-white hover:bg-cetaceanblue"
                            ),
                            disabled: Belt_List.length(selectedLanguageCodesList) === 0,
                            type: "button",
                            onClick: (function (param) {
                                handleValidate();
                              })
                          })
                    ]
                  })
          ) : null;
      }
      tmp$2 = JsxRuntime.jsxs("div", {
            children: [
              tmp$3,
              Belt_List.length(selectedLanguageCodesList) === 0 && importMode !== "Validating" && importMode !== "Importing" ? JsxRuntime.jsx("p", {
                      children: "Select at least one language in step 1 to continue.",
                      className: "mt-3 text-xs text-red-700"
                    }) : null
            ],
            ref: Caml_option.some(fileActionsRef),
            className: "mt-4 p-4 rounded-lg border bg-lavenderweb border-pigmentblue"
          });
    } else {
      var exit = 0;
      if (typeof importMode !== "object" || importMode.TAG !== "Success") {
        exit = 1;
      } else {
        tmp$2 = null;
      }
      if (exit === 1) {
        tmp$2 = JsxRuntime.jsx("p", {
              children: "Upload a file above to enable validation and import.",
              className: "mt-5 text-xs text-aurometalsaurus leading-relaxed"
            });
      }
      
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            summary !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs(SurveyTranslations$StatCard, {
                            label: "Source language",
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: SurveyLanguage$ReactHooksTemplate.name(summary.sourceLanguage),
                                            className: "inline-flex items-center bg-lavenderweb text-darkcharcoal text-sm font-medium px-3 py-1 rounded-full"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: SurveyLanguage$ReactHooksTemplate.code(summary.sourceLanguage),
                                            className: "text-xs text-aurometalsaurus"
                                          })
                                    ],
                                    className: "flex items-center gap-2"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Original survey content. Target languages must differ from this.",
                                    className: "text-xs text-aurometalsaurus mt-3 leading-relaxed"
                                  })
                            ]
                          }),
                      JsxRuntime.jsx(SurveyTranslations$StatCard, {
                            label: "Imported translations",
                            children: Belt_List.length(summary.translationLanguages) > 0 ? JsxRuntime.jsxs("div", {
                                    children: [
                                      $$Array.of_list(Belt_List.map(summary.translationLanguages, renderImportedLanguageBadge)),
                                      JsxRuntime.jsx("p", {
                                            children: "Numbers show how many resources have translations per language.",
                                            className: "text-xs text-aurometalsaurus mt-2 leading-relaxed"
                                          })
                                    ]
                                  }) : JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("p", {
                                            children: "No translations imported yet",
                                            className: "text-sm text-darkcharcoal mb-1"
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: "Complete the steps below to add your first translations.",
                                            className: "text-xs text-aurometalsaurus leading-relaxed"
                                          })
                                    ]
                                  })
                          })
                    ],
                    className: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-8"
                  }) : null,
            summary !== undefined ? renderRespondentLanguageSelectorPanel(summary) : null,
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(SurveyTranslations$StepHeader, {
                          number: 1,
                          title: "Choose target languages",
                          description: "Pick every language you want in the template or upload. You can translate multiple languages in a single file."
                        }),
                    Belt_List.length(availableLanguages) === 0 ? JsxRuntime.jsx("div", {
                            children: "No additional languages are enabled. Ask an admin to enable languages in Settings.",
                            className: "ml-11 p-4 bg-ghostwhitegray border border-gray-300 rounded-lg text-sm text-darkcharcoal"
                          }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("button", {
                                            children: "Select all",
                                            className: "text-xs font-medium text-pigmentblue hover:text-cetaceanblue",
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(setSelectedLanguageCodes, (function (param) {
                                                        return Belt_List.map(availableLanguages, SurveyLanguage$ReactHooksTemplate.code);
                                                      }));
                                                Curry._1(setImportMode, (function (param) {
                                                        return "Idle";
                                                      }));
                                              })
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "|",
                                            className: "text-gray-400"
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: "Clear",
                                            className: "text-xs font-medium text-aurometalsaurus hover:text-darkcharcoal",
                                            type: "button",
                                            onClick: (function (param) {
                                                Curry._1(setSelectedLanguageCodes, (function (param) {
                                                        return /* [] */0;
                                                      }));
                                                Curry._1(setImportMode, (function (param) {
                                                        return "Idle";
                                                      }));
                                              })
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: String(Belt_List.length(selectedLanguageCodesList)) + " selected",
                                            className: "text-xs text-aurometalsaurus ml-2"
                                          })
                                    ],
                                    className: "ml-11 flex flex-wrap items-center gap-2 mb-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: $$Array.of_list(Belt_List.map(availableLanguages, renderLanguageChip)),
                                    className: "ml-11 flex flex-wrap gap-2"
                                  })
                            ]
                          })
                  ],
                  className: "bg-white border border-gray-300 rounded-lg p-6 mb-6"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(SurveyTranslations$StepHeader, {
                          number: 2,
                          title: "Download translation template",
                          description: "Get a spreadsheet with one row per field per language. Only edit the translation column after download."
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: "Include button labels",
                                          className: "text-sm font-medium text-darkcharcoal"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "Adds Next, Back, Skip, Submit, welcome start button, and related labels.",
                                          className: "text-xs text-aurometalsaurus mt-1 leading-relaxed max-w-xl"
                                        })
                                  ],
                                  className: "min-w-0"
                                }),
                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                  checked: includeNavigationMessages,
                                  handleChange: (function (param) {
                                      Curry._1(setIncludeNavigationMessages, (function (previous) {
                                              return !previous;
                                            }));
                                    }),
                                  labelClassName: "flex items-center flex-shrink-0"
                                })
                          ],
                          className: "ml-11 mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-ghostwhitegray border border-gray-200 rounded-lg"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: "Include question error messages",
                                          className: "text-sm font-medium text-darkcharcoal"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: "Adds one row per question for validation text shown when a respondent gives an invalid answer. Most translators can leave this off.",
                                          className: "text-xs text-aurometalsaurus mt-1 leading-relaxed max-w-xl"
                                        })
                                  ],
                                  className: "min-w-0"
                                }),
                            JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                  checked: includeErrorNotifications,
                                  handleChange: (function (param) {
                                      Curry._1(setIncludeErrorNotifications, (function (previous) {
                                              return !previous;
                                            }));
                                    }),
                                  labelClassName: "flex items-center flex-shrink-0"
                                })
                          ],
                          className: "ml-11 mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-ghostwhitegray border border-gray-200 rounded-lg"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("button", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          alt: "",
                                          src: Image$ReactHooksTemplate.csvDownloadButton
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Download CSV"
                                        })
                                  ],
                                  className: "inline-flex items-center gap-2 bg-white border border-gray-400 rounded-lg px-4 py-3 text-sm text-darkcharcoal hover:border-pigmentblue hover:bg-ghostwhitegray disabled:opacity-50 disabled:cursor-not-allowed",
                                  disabled: Belt_List.length(selectedLanguageCodesList) === 0,
                                  type: "button",
                                  onClick: (function (param) {
                                      downloadTemplate(surveyId, selectedLanguageCodesList, "csv", includeErrorNotifications, includeNavigationMessages);
                                    })
                                }),
                            JsxRuntime.jsxs("button", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          alt: "",
                                          src: Image$ReactHooksTemplate.downloadBox
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: "Download XLSX"
                                        })
                                  ],
                                  className: "inline-flex items-center gap-2 bg-white border border-gray-400 rounded-lg px-4 py-3 text-sm text-darkcharcoal hover:border-pigmentblue hover:bg-ghostwhitegray disabled:opacity-50 disabled:cursor-not-allowed",
                                  disabled: Belt_List.length(selectedLanguageCodesList) === 0,
                                  type: "button",
                                  onClick: (function (param) {
                                      downloadTemplate(surveyId, selectedLanguageCodesList, "xlsx", includeErrorNotifications, includeNavigationMessages);
                                    })
                                })
                          ],
                          className: "ml-11 flex flex-wrap gap-3"
                        }),
                    Belt_List.length(selectedLanguageCodesList) === 0 ? JsxRuntime.jsx("p", {
                            children: "Select at least one language to enable downloads.",
                            className: "ml-11 mt-3 text-xs text-aurometalsaurus"
                          }) : (
                        !includeErrorNotifications || !includeNavigationMessages ? JsxRuntime.jsx("p", {
                                children: !includeNavigationMessages && !includeErrorNotifications ? "Button label and error message rows will not be included in this download." : (
                                    includeNavigationMessages ? "Error message rows will not be included in this download." : "Button label rows (including welcome start button) will not be included in this download."
                                  ),
                                className: "ml-11 mt-3 text-xs text-aurometalsaurus"
                              }) : null
                      )
                  ],
                  className: "bg-white border border-gray-300 rounded-lg p-6 mb-6"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(SurveyTranslations$StepHeader, {
                          number: 3,
                          title: "Upload and import",
                          description: "Upload your completed file, validate it, then import. Do not change language_code, resource_id, or field_key columns."
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(SurveyTranslations$UploadWorkflowSteps, {
                                  importMode: importMode,
                                  hasFile: selectedFile !== undefined
                                }),
                            JsxRuntime.jsx("input", {
                                  ref: Caml_option.some(fileInputRef),
                                  className: "hidden",
                                  accept: ".csv,.xlsx",
                                  type: "file",
                                  onChange: handleFileChange
                                }),
                            tmp$1,
                            fileUploadError !== undefined ? JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(SurveyTranslations$FileUploadAlert, {
                                          title: "File cannot be used",
                                          message: fileUploadError
                                        }),
                                    className: "mt-3"
                                  }) : null,
                            showResultStatusPanel ? JsxRuntime.jsx("div", {
                                    children: renderStatusPanel(),
                                    className: "mt-4"
                                  }) : null,
                            tmp$2
                          ],
                          className: "ml-11"
                        })
                  ],
                  ref: Caml_option.some(uploadSectionRef),
                  className: "bg-white border border-gray-300 rounded-lg p-6 mb-8"
                })
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Survey Translations",
                                      className: "text-2xl font-semibold text-darkcharcoal mb-2"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Translate your survey for multiple audiences in one workflow. Select languages, download a combined template, fill translations offline, then upload once to apply everything.",
                                      className: "text-sm text-aurometalsaurus leading-relaxed max-w-3xl"
                                    })
                              ],
                              className: "mb-8 border-b border-lavenderweb pb-6"
                            }),
                        tmp
                      ],
                      className: "p-6 md:p-8 max-w-5xl mx-auto"
                    }),
                languageToRemove !== undefined ? JsxRuntime.jsx(SurveyTranslations$RemoveLanguageDialog, {
                        language: languageToRemove,
                        confirming: Caml_obj.equal(removalSavingCode, languageToRemove.code),
                        onCancel: cancelRemoveLanguage,
                        onConfirm: (function (param) {
                            Curry._1(setRemovalSavingCode, (function (param) {
                                    return languageToRemove.code;
                                  }));
                            Curry._1(setRemovalError, (function (param) {
                                    
                                  }));
                            Js_promise.$$catch((function (param) {
                                    Curry._1(setRemovalSavingCode, (function (param) {
                                            
                                          }));
                                    Curry._1(setRemovalError, (function (param) {
                                            return "Network error while removing translations.";
                                          }));
                                    return Promise.resolve();
                                  }), Js_promise.then_((function (json) {
                                        var status = Json_decode.field("status", (function (param) {
                                                return Json_decode.withDefault("failure", Json_decode.string, param);
                                              }), json);
                                        if (status === "success") {
                                          var summaryData = Json_decode.field("data", decodeSummary, json);
                                          Curry._1(setSummary, (function (param) {
                                                  return summaryData;
                                                }));
                                          Curry._1(setSelectedLanguageCodes, (function (prev) {
                                                  return Belt_List.keep(prev, (function (code) {
                                                                return code !== languageToRemove.code;
                                                              }));
                                                }));
                                          Curry._1(setRemovalError, (function (param) {
                                                  
                                                }));
                                          Curry._1(setLanguageToRemove, (function (param) {
                                                  
                                                }));
                                        } else {
                                          var message = Json_decode.field("message", (function (param) {
                                                  return Json_decode.withDefault("Failed to remove translations.", Json_decode.string, param);
                                                }), json);
                                          Curry._1(setRemovalError, (function (param) {
                                                  return message;
                                                }));
                                        }
                                        return Promise.resolve(Curry._1(setRemovalSavingCode, (function (param) {
                                                          
                                                        })));
                                      }), removeTranslations(surveyId, languageToRemove.code)));
                          })
                      }) : null
              ]
            });
}

var maxTranslationFileBytes = 5242880;

var make = SurveyTranslations;

exports.decodeTranslationLanguage = decodeTranslationLanguage;
exports.decodeSummary = decodeSummary;
exports.decodeIssue = decodeIssue;
exports.decodeWarning = decodeWarning;
exports.decodeImportSummary = decodeImportSummary;
exports.decodeValidationResult = decodeValidationResult;
exports.decodeValidationResponse = decodeValidationResponse;
exports.fetchSummary = fetchSummary;
exports.updateSelectorVisibility = updateSelectorVisibility;
exports.updateLanguageSelectorPosition = updateLanguageSelectorPosition;
exports.removeTranslations = removeTranslations;
exports.fetchEnabledLanguages = fetchEnabledLanguages;
exports.downloadTemplate = downloadTemplate;
exports.appendLanguageCodes = appendLanguageCodes;
exports.uploadTranslationFile = uploadTranslationFile;
exports.languageNameForCode = languageNameForCode;
exports.StepHeader = StepHeader;
exports.StatCard = StatCard;
exports.RemoveLanguageDialog = RemoveLanguageDialog;
exports.languageTableRowClass = languageTableRowClass;
exports.languageTableRowInnerClass = languageTableRowInnerClass;
exports.languageDropdownColumnClass = languageDropdownColumnClass;
exports.languageManageColumnClass = languageManageColumnClass;
exports.languageTableHeaderClass = languageTableHeaderClass;
exports.fileDisplayName = fileDisplayName;
exports.translationFileSize = translationFileSize;
exports.maxTranslationFileBytes = maxTranslationFileBytes;
exports.allowedTranslationExtension = allowedTranslationExtension;
exports.importedLanguageCodes = importedLanguageCodes;
exports.uploadStepStateClass = uploadStepStateClass;
exports.selectedFileCardState = selectedFileCardState;
exports.UploadWorkflowSteps = UploadWorkflowSteps;
exports.FileUploadAlert = FileUploadAlert;
exports.make = make;
/* react Not a pure module */
